<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">Start your highlight reel</div>
    <div class="modal--subtitle">
      You have {{ availableReels.length }} credits. Complete the highlight reel forms to redeem.
    </div>
  </section>

  <section class="modal-content-container">
    <div class="hr-list">
      <div class="hr-list--item-wrapper">
        <div class="hr-item" *ngFor="let reel of availableReels">
          <div class="data mr-10">
            <p class="">Highlight Reel {{ reel.type | titlecase }}</p>
            <p class="mt-5">Purchased {{ reel.purchase?.createdAt | date: 'MMM dd, y' }}</p>
          </div>

          <div class="actions flex items-center">
            <button class="btn btn-lg btn-text font-normal" (click)="goToForm(reel.purchase.id)">
              <span class="mr-9 text-container text-md">
                <span>Complete Form</span>
                <span *ngIf="reel.draft" class="text-base mt-2"
                  ><span class="saved-on">Draft saved on </span> {{ reel.updatedAt | date: 'MMM dd, y' }}</span
                >
              </span>
              <svg-icon src="/assets/images/svg/icons/misc/arrow-right-gray.svg"></svg-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="modal-actions-container">
    <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
  </section>
</div>
